import React, { Component } from "react";
import { ListingContext } from "../../Context";
import _ from "lodash";

import SkeletonText from "../../components/skeleton/SkeletonText";

export default class ListingExtras extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          if (listingContext.loading) {
            return (
              <div className="listing-extras">
                <SkeletonText lines={4} />
              </div>
            );
          } else if (!_.isEmpty(listing.extras)) {
            return (
              <div className="listing-extras">
                <h5 className="listing-section__title">Extras</h5>
                <p>{listing.extras}</p>
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingExtras.js